module.exports = __webpack_public_path__ + "img/edit-event-details.ccadf6e9.svg";